export class VueClassicModalPopUpViewModel {
  public static createEmpty(): VueClassicModalPopUpViewModel {
    return new VueClassicModalPopUpViewModel();
  }

  constructor(
    public IsVisible: boolean = false,
    public LeftPanelContent: string = '',
    public RightPanelContent: string = '',
    public Button1Text: string = '',
    public Button2Text: string = '',
    public ContinueButtonText: string = '',
  ) { }
}
